import { render, staticRenderFns } from "./Pics.vue?vue&type=template&id=c5ea62f0&scoped=true&"
import script from "./Pics.vue?vue&type=script&lang=js&"
export * from "./Pics.vue?vue&type=script&lang=js&"
import style0 from "./Pics.vue?vue&type=style&index=0&id=c5ea62f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ea62f0",
  null
  
)

export default component.exports